import {Component, Inject} from '@angular/core';
import {Utils} from '../../utils/utils';
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";


@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent {
  model: { photo: string; label: string; resizeTo: number; };


  constructor(
    private dialogRef: DialogRef<string>,
    @Inject(DIALOG_DATA) private data: { photo: string; label: string; resizeTo: number; }
  ) {
    this.model = this.data;
  }


  onRemoveBtnClicked() {
    this.dialogRef.close(null);
  }

  selectImage() {
    document.getElementById('input_' + this.model?.label).click();
  }

  public async processFile(e: Event) {
    const file = (e.target as HTMLInputElement)?.files[0];
    const dataUrl = await Utils.resizeImage(file, this.model.resizeTo, true);

    const htmlImageElement = document.getElementById('image_' + this.model.label) as HTMLImageElement;
    htmlImageElement.src = dataUrl.toString();

    this.model.photo = dataUrl.toString().split(';base64,')[1];
    this.dialogRef.close(this.model.photo);
  }

  close() {
    this.dialogRef.close(undefined);
  }
}
